import { render, staticRenderFns } from "./apiErrcodeTable.vue?vue&type=template&id=42672cb0"
import script from "./apiErrcodeTable.vue?vue&type=script&lang=js"
export * from "./apiErrcodeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports